import { SummaryActionTypes } from "./summary.types";

export const setAuditModalVisibility = isVisible => {
  return {
    type: SummaryActionTypes.SET_SUMMARY_MODAL_VISIBILITY,
    payload: isVisible
  };
};
